import { render, staticRenderFns } from "./CompanionMarketOverview.vue?vue&type=template&id=8cd06be0&scoped=true&"
import script from "./CompanionMarketOverview.vue?vue&type=script&lang=js&"
export * from "./CompanionMarketOverview.vue?vue&type=script&lang=js&"
import style0 from "./CompanionMarketOverview.vue?vue&type=style&index=0&id=8cd06be0&prod&lang=sass&scoped=true&"
import style1 from "./CompanionMarketOverview.vue?vue&type=style&index=1&id=8cd06be0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd06be0",
  null
  
)

export default component.exports